export function isProduction() {
  return (typeof window !== 'undefined') ? window.location.host === 'static.ccrgt.com' : false;
}

export const userAuthorUrl = isProduction()
  ? 'https://apicloud.ccrgt.com/crgt/user-center/userActivity'
  : 'https://t-apicloud.ccrgt.com/crgt-test/user-center/userActivity';

export const activityUrl = isProduction()
  ? 'https://fe-bp-dynamic-activity.ccrgt.com'
  // ? 'http://127.0.0.1:7001'
  : 'https://t-fe-bp-dynamic-activity.ccrgt.com';

